import * as React from 'react';
import { connect } from 'react-redux';
import { AppConstants } from '../../constants/AppConstants';
import { Utils, domainVal, NumberFormatter, DateFormatter, i18n } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import GaranzieActions from './garanzie_actions'
import MicroCategoriaActions from '../microCategorie/microCaterogieActions'
import ApplicationData from '../../app/aApplicationData';
import ProdottoActions from './../prodotto/prodotto_actions.js';

class GaranzieTable extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[GaranzieTable.jsx] ';
        this.aggiungiGaranziaOnClick = this.aggiungiGaranziaOnClick.bind(this);
        this.columnNameProdottoBase = this.columnNameProdottoBase.bind(this);
    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    domainFormatter(value, row, index) {
        return ApplicationData.domainVal('AI_TIPO_COPERTURA', value, value).desDom
    }

    infoFormatter(value, row, index) {
        let temp;
        let info = null;
        if (row.prodottoGaranzia !== undefined && row.prodottoGaranzia !== null) {
            info = row.prodottoGaranzia.cmpGarInfo;
        }

        if (info !== undefined && info !== null && info !== '') {
            info = info.split('\'').join(' ');
            temp = "<i class='fas fa-info-circle' title='" + info + "' ></i>";
        }
        return temp;
    }

    codBisognoFormatter(value, row, index) {
        return ApplicationData.domainVal('AI_BISOGNO', value, value).desDom;
    }

    ramoGaranziaFormatter(value, row, index) {
        return ApplicationData.domainVal('AI_RAMO_GARANZIA', value, value).desDom;
    }

    aggiungiGaranziaOnClick(row, $element, field) {
        this.props.aggiungiGaranziaOnClick(row);
    }

    tipoCoperturaFormatter(value, row, index) {
        if (value !== undefined && value !== null) {
            let title = ApplicationData.domainVal('AI_TIPO_COPERTURA', value, value).desDom;
            if (value === 'OB') {  // obbligatoria
                return "<i class='fas fa-check' title='" + title + "'></i>";
            } else if (value === 'FA') {  // facoltativa
                return "<i class='far fa-check-square' title='" + title + "'></i>";
            } else if (value === 'NP') {  // non prevista
                return "<i class='fas fa-ban' title='" + title + "'></i>";
            } else if (value === 'DD') {  // da definire
                return "<i class='fas fa-spinner' title='" + title + "'></i>";
            }
            return " ";
        }
        return '-';
    }

    columnNameProdottoBase(value, row, index) {
        let temp;
        if (row !== null && row !== undefined && row.prodottoGaranzia !== null && row.prodottoGaranzia !== undefined && row.prodottoGaranzia.nomeProdottoBase !== null
            && row.prodottoGaranzia.nomeProdottoBase !== undefined && row.prodottoGaranzia.idProdottoBase != null & row.prodottoGaranzia.idProdottoBase != undefined) {
            temp = value + " - " + "<b><i>" + row.prodottoGaranzia.nomeProdottoBase + "</i></b>";
        } else {
            temp = value;
        }
        return temp;
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        // Definisco le colonne della boostrap table
        let columns = [];
        if (this.props.source && this.props.source === "gpCreate") {
            columns = [
                { field: 'id', title: 'Id', sortable: 'true' },
                { field: 'nome', title: i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome'), sortable: 'true' },
                { field: 'sigla', title: i18n('ARM_CORE_PRODUCT.GARANZIE.SIGLA', 'Sigla'), sortable: 'true' },
                { field: 'codBisogno', title: i18n('ARM_CORE_PRODUCT.GARANZIE.BISOGNO', 'Bisogno'), sortable: 'true', formatter: this.codBisognoFormatter },
                { field: 'codRamo', title: i18n('ARM_CORE_PRODUCT.GARANZIE.RAMO_GARANZIA', 'Ramo Garanzia'), sortable: 'true', formatter: this.ramoGaranziaFormatter },
                { field: 'info', title: '', formatter: this.columnSelect },
            ];
        }
        else if (this.props.source && this.props.source === "gpDetails") {
            columns = [
                { field: 'ordine', title: '#', sortable: 'true' },
                { field: 'garanzia.id', title: 'Id', sortable: 'true' },
                { field: 'garanzia.nome', title: i18n('ARM_CORE_PRODUCT.SHARED.GARANZIA', 'Garanzia'), sortable: 'true' },
                { field: 'garanzia.sigla', title: i18n('ARM_CORE_PRODUCT.GARANZIE.SIGLA', 'Sigla'), sortable: 'true' },
                { field: 'garanzia.codBisogno', title: i18n('ARM_CORE_PRODUCT.GARANZIE.BISOGNO', 'Bisogno'), sortable: 'true', formatter: this.codBisognoFormatter },
                { field: 'garanzia.codRamo', title: i18n('ARM_CORE_PRODUCT.GARANZIE.RAMO_GARANZIA', 'Ramo Garanzia'), sortable: 'true', formatter: this.ramoGaranziaFormatter },
                { field: 'info', title: i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info'), formatter: this.columnDetail },
            ];
        }
        else if (this.props.source && this.props.source === "prodottoDetails") {
            columns = [
                { field: 'microCategoriaGaranzia.ordine', title: '#', sortable: 'true' },
                { field: 'garanzia.id', title: 'Id', sortable: 'true' },
                { field: 'garanzia.nome', title: i18n('ARM_CORE_PRODUCT.SHARED.GARANZIA', 'Garanzia'), sortable: 'true', formatter: this.columnNameProdottoBase, },
                { field: 'prodottoGaranzia.tipoCopertura', title: i18n('ARM_CORE_PRODUCT.GARANZIE.COPERTURA', 'Copertura'), sortable: 'true', align: 'center', formatter: this.tipoCoperturaFormatter },
                { field: 'garanzia.codBisogno', title: i18n('ARM_CORE_PRODUCT.GARANZIE.BISOGNO', 'Bisogno'), sortable: 'true', formatter: this.codBisognoFormatter },
                { field: 'garanzia.sigla', title: i18n('ARM_CORE_PRODUCT.GARANZIE.SIGLA', 'Sigla'), sortable: 'true' },
                { field: 'prodottoGaranzia.cmpGarNome', title: i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info'), sortable: 'true', formatter: this.infoFormatter },
                { field: 'info', title: i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLIO', 'Dettaglio'), formatter: this.columnDetail },
            ];
        }

        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "garanzia.id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],

            onClickRow: (row, $element, field) => this.props.source && this.props.source === "gpCreate" ? this.aggiungiGaranziaOnClick(row, $element, field) :
                (this.props.source && (this.props.source === "gpDetails" || this.props.source === "prodottoDetails")) ? this.detailsOnClick(row, $element, field) :
                    null
            ,
            sortOrder: "desc",
            pagination: true,
        });
    }

    columnSelect(value, row, index) {
        console.log("columnSelect:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm title='" + i18n('ARM_CORE_PRODUCT.SHARED.AGGIUNGI', 'Aggiungi') + "'><i class='fas fa-mouse-pointer'></i></button>";
        return temp;
    }

    columnDetail(value, row, index) {
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-info fa-fw'/></button>";
        return temp;
    }

    detailsOnClick(row, $element, field) {
        console.log(this.componentName + "detailsOnClick [field] " + field);

        this.props.history.push({
            pathname: '/garanzie/details', state: {
                id: row.garanzia.id,
                goBackOfHistory: true
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps.rows !== null ? nextProps.rows.length : "NULL"));

            if (nextProps.rows === null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
            }
        }

    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="card-body">
                <table ref="MyTable" className={AppConstants.CLASS_TABLE} />
            </div>
        );
    }
};

function mapStateToProps(state, ownProps) {
    return {
        prodotto: state.prodotto.detailsProdotto,
        garanzia: state.garanzie.detailsGaranzia,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListGaranzie() {
            return dispatch(GaranzieActions.getListGaranzie());
        },
        clearAll() {
            return dispatch(GaranzieActions.clearAll());
        },
        aggiungiGaranziaOnClick(row) {
            return dispatch(MicroCategoriaActions.aggiungiGaranziaOnClick(row));
        },
        getProdottoDetails(id) {
            return dispatch(ProdottoActions.getProdottoDetails(id));
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GaranzieTable);